import { render, staticRenderFns } from "./groundPromotionManage.vue?vue&type=template&id=621b35de"
import script from "./groundPromotionManage.vue?vue&type=script&lang=js"
export * from "./groundPromotionManage.vue?vue&type=script&lang=js"
import style0 from "./groundPromotionManage.vue?vue&type=style&index=0&id=621b35de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports